import styled from 'styled-components';

const Link = styled.a`
  &&& {
    color: ${props => props.theme.primaryColor};
  }
`;

const Separator = styled.div`
  height: 0px;
  border-bottom: 1px solid ${props => props.theme.secondaryColorLight};
  margin-top: 20px;
  margin-bottom: 20px;
`;

export {
  Link,
  Separator,
};
